import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { apiClient } from 'mobx-rest'
import adapter from 'mobx-rest-fetch-adapter'
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

//const apiPath = 'https://localhost:444'
const apiPath = 'https://api.rivertrack.org'
apiClient(adapter, { apiPath })

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js